var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { OnInit, OnDestroy } from '@angular/core';
import { ContactComponent } from './contact.component';
import { SidebarService } from '@ibe/services/ui';
import { Router } from '@angular/router';
import { INDRABFMDataStorageService } from '@ibe.services/bfm-data-storage.indra.service';
import { INDRAIbeAdminService } from '@ibe.services/ibeadmin.indra.service';
import { INDRAParallelService } from '@ibe.services/parallel.indra.service';
var INDRAContactComponent = /** @class */ (function (_super) {
    __extends(INDRAContactComponent, _super);
    function INDRAContactComponent(sidebarService, bfmStorage, ibeAdminService, router, parallelService) {
        var _this = _super.call(this) || this;
        _this.sidebarService = sidebarService;
        _this.bfmStorage = bfmStorage;
        _this.ibeAdminService = ibeAdminService;
        _this.router = router;
        _this.parallelService = parallelService;
        _this.allSubs = [];
        _this._has_details = false;
        _this.contactsCreated = false;
        _this.no_edit = false;
        if (_this.bfmStorage.INDRA_getCountryCodes()) {
            _this.countryCodes = _this.bfmStorage.INDRA_getCountryCodes();
        }
        _this.INDRA_assignValues();
        _this.booked_trip = _this.bfmStorage.INDRA_getActiveBookedTrip();
        return _this;
    }
    /**
     * get the list of phone numbers to print
     *
     * @param {*} values
     * @returns
     * @memberof INDRAContactComponent
     */
    INDRAContactComponent.prototype.INDRA_getPhoneNumbers = function (values) {
        var primaryPrefixValue = '';
        var plusSign = new RegExp("\\+"); // + sign
        if (values.phoneCountryCode) {
            primaryPrefixValue = values.phoneCountryCode.search(plusSign) == 0 ? values.phoneCountryCode : '+' + values.phoneCountryCode;
        }
        return primaryPrefixValue + values.phone;
    };
    /**
     * Get booking secondary phone contact details
     * returns the array of the secondary phone numbers
     *
     * @param {string} dialCode
     * @param {*} secondaryPhones
     * @returns
     * @memberof INDRAContactComponent
     */
    INDRAContactComponent.prototype.INDRA_getSecondaryPhoneNumbersObject = function (secondaryPhones) {
        var newSecondaryPhoneNumbers = [];
        if (secondaryPhones && secondaryPhones['secondaryTelephones'] && secondaryPhones['secondaryTelephones'].length > 0) {
            secondaryPhones.secondaryTelephones.forEach(function (element, index) {
                // const dialCode = this.INDRA_getDialCode(element.countryCode);
                if (index == 0) {
                    var plusSign = new RegExp("\\+"); // + sign
                    var dialCode = null;
                    if (element.countryCode) {
                        dialCode = element.countryCode.search(plusSign) == 0 ? element.countryCode : '+' + element.countryCode;
                    }
                    if (dialCode) {
                        newSecondaryPhoneNumbers.push(dialCode + element.telephone);
                    }
                    else {
                        newSecondaryPhoneNumbers.push(element.telephone);
                    }
                }
            });
        }
        return newSecondaryPhoneNumbers.join('; ');
    };
    /**
     * Get the dial code of a country
     *
     * @param {*} countryCode
     * @returns {string}
     * @memberof INDRAContactComponent
     */
    INDRAContactComponent.prototype.INDRA_getDialCode = function (countryCode) {
        var country = this.countryCodes.find(function (item) { return item.code === countryCode; });
        return country ? country.dial_code : '';
    };
    INDRAContactComponent.prototype.ngOnInit = function () {
        var _this = this;
        var currentBookingSubscription = this.bfmStorage.observableCurrentBooking.subscribe(function (data) {
            _this.INDRA_assignValues();
        });
        this.allSubs.push(currentBookingSubscription);
    };
    /**
     * Check if booking already has contact details
     */
    INDRAContactComponent.prototype.INDRA_hasContactDetails = function () {
        return this._has_details;
    };
    /**
     * Prints label of link to add/edit contact details
     */
    INDRAContactComponent.prototype.INDRA_printLinkLabel = function () {
        return this.INDRA_getTranslation(this.INDRA_printLinkLabelKey());
    };
    INDRAContactComponent.prototype.INDRA_printLinkLabelKey = function () {
        return this._has_details ? 'bookingDetails.link.editContact' : 'bookingDetails.link.addContact';
    };
    /**
     * Prints CSS classes of link
     */
    INDRAContactComponent.prototype.INDRA_printLinkClasses = function () {
        return {
            display: !this._has_details ? 'block' : 'flex'
        };
    };
    /**
     * Prints contact details box label
     */
    INDRAContactComponent.prototype.INDRA_printLabel = function (contact) {
        return contact.label;
    };
    /**
     * Has contact value
     */
    INDRAContactComponent.prototype.INDRA_hasContactValue = function (contact) {
        return contact.value !== undefined && contact.value !== '';
    };
    /**
     * Prints contact value (phone number or email, ...)
     */
    INDRAContactComponent.prototype.INDRA_printContactValue = function (contact) {
        return contact.value;
    };
    /**
     * Prints contact label (phone number or email, ...)
     */
    INDRAContactComponent.prototype.INDRA_printContactLabel = function (contact) {
        return contact.label;
    };
    /**
     * Prints contact details box description
     */
    INDRAContactComponent.prototype.INDRA_printDescription = function (contact) {
        return contact.description;
    };
    /**
     * Tells if is first or last contact
     */
    INDRAContactComponent.prototype.INDRA_shouldShow = function (index) {
        var shouldShow = index === this.contacts.length - 1 || index === 0;
        if (shouldShow && !this.contactsCreated) {
            this.parallelService.INDRA_setIsContactCreated(true);
            this.contactsCreated = true;
        }
        return shouldShow;
    };
    /**
     * Open Sidebar
     */
    INDRAContactComponent.prototype.INDRA_handleOpenSidebar = function () {
        this.sidebarService.openSidebar(['contacts', { pnr: this.pnr }]);
    };
    INDRAContactComponent.prototype.INDRA_getTranslation = function (key) {
        return this.ibeAdminService.getTranslationValueAsync(key);
    };
    INDRAContactComponent.prototype.INDRA_assignValues = function () {
        if (this.bfmStorage.INDRA_getActiveBookInfoPax()) {
            var infoPax = this.bfmStorage.INDRA_getActiveBookInfoPax();
            this.INDRA_getSecondaryPhoneNumbersObject(infoPax);
            var PHONES = [{
                    label: this.INDRA_getTranslation('bookingDetails.label.primaryPhone'),
                    labelKey: 'bookingDetails.label.primaryPhone',
                    value: this.INDRA_getPhoneNumbers(infoPax) === 'null' || !this.INDRA_getPhoneNumbers(infoPax) ? ' ' : this.INDRA_getPhoneNumbers(infoPax)
                },
                {
                    label: this.INDRA_getSecondaryPhoneNumbersObject(infoPax) ? this.INDRA_getTranslation('bookingDetails.label.secondaryPhone') : '',
                    labelKey: this.INDRA_getSecondaryPhoneNumbersObject(infoPax) ? 'bookingDetails.label.secondaryPhone' : '',
                    value: this.INDRA_getSecondaryPhoneNumbersObject(infoPax) ? this.INDRA_getSecondaryPhoneNumbersObject(infoPax) : ''
                }];
            if (!infoPax.phone && !infoPax.prefixPhone && !infoPax.email) {
                this._has_details = false;
            }
            else {
                this._has_details = true;
            }
            this.contacts = [
                {
                    label: this.INDRA_getTranslation('bookingDetails.label.email'),
                    labelKey: 'bookingDetails.label.email',
                    values: [
                        {
                            label: this.INDRA_getTranslation('bookingDetails.label.email'),
                            labelKey: 'bookingDetails.label.email',
                            value: infoPax.email
                        }
                    ],
                    description: this.INDRA_getTranslation('bookingDetails.text.confirmationEmail'),
                    descriptionKey: 'bookingDetails.text.confirmationEmail',
                },
                {
                    label: this.INDRA_getTranslation('bookingDetails.label.phoneNumber'),
                    labelKey: 'bookingDetails.label.phoneNumber',
                    values: PHONES,
                    description: this.INDRA_getTranslation('bookingDetails.text.contactPhone'),
                    descriptionKey: 'bookingDetails.text.contactPhone',
                }
            ];
        }
    };
    INDRAContactComponent.prototype.INDRA_isGroupBooking = function () {
        return this.booked_trip.data.group;
    };
    INDRAContactComponent.prototype.ngOnDestroy = function () {
        for (var _i = 0, _a = this.allSubs; _i < _a.length; _i++) {
            var sub = _a[_i];
            sub.unsubscribe();
        }
    };
    return INDRAContactComponent;
}(ContactComponent));
export { INDRAContactComponent };
